import { render, staticRenderFns } from "./ReportingPlagueMonitoring.vue?vue&type=template&id=5c39090e&scoped=true&lang=html&"
import script from "./ReportingPlagueMonitoring.vue?vue&type=script&lang=js&"
export * from "./ReportingPlagueMonitoring.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39090e",
  null
  
)

export default component.exports